module.exports = __webpack_public_path__ + "static/media/ARC-Desk-portal.ba8840ba.jpg";